import { Text, View, Image } from "@react-pdf/renderer";
import styles from '../styles/styles';

interface HeaderProps {
  labels: {
    title: string;
    date: string;
    estate: string;
    company: string;
    projectTitle: string;
    taskTitle: string;
    // taskID: string;
    responsible: string;
    note: string;
  };
  data: {
    date: string;
    estate: string;
    company: string;
    projectTitle: string;
    taskTitle: string;
    // taskID: string;
    responsible: string;
    note: string;
  };
  logoSrc?: string | null;
}

const Header = ({ labels, data, logoSrc }: HeaderProps) => (
  <>
  <View style={styles.headerRow}>
      {/* Left side */}
      <View style={{ flex: 1 }}>
        <Text style={styles.header}>{labels.title}</Text>
        <Text>{labels.date}: {data.date}</Text>
      </View>

      {/* Right side */}
      {logoSrc && (
        <View style={{ flex: 1, alignItems: "flex-end" }}>
          <Image
            src={logoSrc}
            style={{
              width: 140,
              height: 24,
              objectFit: "contain"
            }}
          />
        </View>
      )}
    </View>

    <View style={styles.spacer} />

    <View>
      <View style={styles.row}>
        {/* Left */}
        <View>
          <Text style={styles.label}>{labels.estate}:</Text>
          <Text>{data.estate}</Text>

          <View style={styles.spacer} />

          <Text style={styles.label}>{labels.projectTitle}:</Text>
          <Text>{data.projectTitle}</Text>

          <View style={styles.spacer} />

          <Text style={styles.label}>{labels.taskTitle}:</Text>
          <Text>{data.taskTitle}</Text>

          {/* <View style={styles.spacer} />

          <Text style={styles.label}>{labels.taskID}:</Text>
          <Text>{data.taskID}</Text> */}
        </View>

        {/* Right */}
        <View style={styles.headerRight}>
          <Text style={styles.label}>{labels.company}:</Text>
          <Text>{data.company}</Text>

          <View style={styles.spacer} />

          <Text style={styles.label}>{labels.responsible}:</Text>
          <Text>{data.responsible}</Text>
        </View>
      </View>

      <View style={styles.spacer} />

      <View style={styles.row}>
        {/* Left */}
        <View>
          <Text style={styles.label}>{labels.note}:</Text>
          <Text>{data.note}</Text>
        </View>

        {/* Right */}
      </View>
    </View>
  </>
);

export default Header;